// Handles legacy routes to modal content.
// We used to have modal routes in the form of:
//     /domain/course/unit/modal/v/slug
//
// The new modal form is:
//     /domain/course/unit/lesson/v/slug?modal=1
//
// This requires content lookups by slug, so the domain logic for doing this
// lives in GraphQL (curatedContentModalRedirect)
//
// We no longer have internal references to this form, but there are plenty
// of external requests. This handler can be removed when we no longer receive
// outside requests to .*/modal/.* routes
import * as React from "react";
import {Redirect} from "react-router-dom";

type Props = {
    path: string;
    search: string;
};

export default function LegacyModalRedirect({
    path,
    search,
}: Props): React.ReactElement {
    // Remove the /modal/ from old modal urls. Content library will either
    // load the content if the URL is valid or redirect to the best DCUL
    // based path for the content.
    const pathWithoutModal = path.replace("/modal/", "/");
    // This parsing will handle if there's a ? or not.
    // Then turning it into a string we know to add the ? ourselves.
    const params = new URLSearchParams(search);
    const searchString = params.size > 0 ? `?${params.toString()}` : "";
    return <Redirect to={`${pathWithoutModal}${searchString}`} />;
}
